<template>
  <img
    :src="src"
    :alt="alt"
    :class="classes"
    v-bind="attrsWithoutClass"
  >
</template>

<script setup>
import { computed, useAttrs } from 'vue'
import { loadIcon } from '../../utils/loadIcon'
import { cn } from '../../utils/cn'

const props = defineProps({
  icon: { type: String, default: '' },
  src: { type: String, default: '' },
  alt: { type: String, default: '' },
  size: { type: String, default: '' },
  spin: { type: Boolean, default: false },
  invert: { type: Boolean, default: false }
})

const baseClass = 'inline-block shrink-0 object-contain'

const src = computed(() => {
  if (props.src) return props.src
  if (props.icon) return loadIcon(props.icon)
  return ''
})

const attrs = useAttrs()

const attrsWithoutClass = computed(() => {
  const { class: _class, ...rest } = attrs
  return rest
})

const classes = computed(() =>
  cn(
    baseClass,
    props.size,
    props.spin && 'animate-spin',
    props.invert && 'filter brightness-0 invert',
    attrs.class
  )
)
</script>
